import { PageRoutes } from '../../app/pages/domain/constants/PageRoutes';
import { PoiListScope } from '../search/domain/models/PoiListScope';
import {
	POI_LOCATION_URL_PARAM_ALL,
	POI_URL_PARAM_ALL,
} from '../search/domain/models/POILocations';
import { formatLocationForUrl } from '../search/domain/utils/formatLocationForUrl';

export function getShopDineRelaxListUrl(
	options: {
		scope?: PoiListScope;
		query?: string;
		location?: string | null;
	},
	retainCurrentQueryParams = true,
) {
	const params = retainCurrentQueryParams
		? new URL(window.location.href).searchParams
		: new URLSearchParams();

	const { scope, query, location } = options;

	if (scope) {
		params.set('scope', scope);
	}

	if (query) {
		params.set('query', query);
	}

	if (query === '') params.delete('query');

	if (location) {
		params.set(
			'location',
			formatLocationForUrl(
				location === POI_LOCATION_URL_PARAM_ALL ? POI_URL_PARAM_ALL : location,
			),
		);
	}

	const url = `${PageRoutes.ShopDineRelax}/?${params.toString()}`;
	return url;
}
